import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import Icon from '../../../components/icon/Icon';
import Button from '../../../components/bootstrap/Button';
import Page from '../../../layout/Page/Page';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import useDarkMode from '../../../hooks/useDarkMode';
import FormGroup from '../../../components/bootstrap/forms/FormGroup';
import { FormikHelpers, useFormik } from 'formik';
import Card, { CardBody, CardHeader } from '../../../components/bootstrap/Card';
import Input from '../../../components/bootstrap/forms/Input';
import PaginationButtons, { PER_COUNT } from '../../../components/PaginationButtons';
import { getUsers } from '../../../services/users';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import classNames from 'classnames';
import Dropdown, { DropdownItem, DropdownMenu, DropdownToggle } from '../../../components/bootstrap/Dropdown';
import OffCanvas, { OffCanvasBody, OffCanvasHeader, OffCanvasTitle } from '../../../components/bootstrap/OffCanvas';
import Modal, { ModalBody, ModalFooter, ModalHeader } from '../../../components/bootstrap/Modal';
import { addShedule, deleteShedule, editSchedule, getSchedules, getSchedulesById, scheduleStatusChange } from '../../../services/pushNotification';
import Select, { ActionMeta, MultiValue } from 'react-select';
import SvgDeleteForever from '../../../components/icon/material-icons/DeleteForever';
import Spinner from '../../../components/bootstrap/Spinner';

interface FormValues {
	notification: {
		title: string;
		body: string;
	};
	data: {
		from: string;
	};
	to: any[];
	scheduledAt: string;
}

interface User {
	_id: string;
	fName: string;
	lName: string;
	email: string;
}

const PushNotificationPage = () => {
	const { themeStatus, darkModeStatus } = useDarkMode();
	const [notifications, setNotifications] = useState<any[]>([]);
	const [isLoadingTemplate, setIsLoadingTemplate] = useState<boolean>(true);
	const [currentPage, setCurrentPage] = useState(1);
	const [perPage, setPerPage] = useState(PER_COUNT['5']);
	const [searchKeyword, setSearchKeyword] = useState('');
	const [upcomingEventsAddModal, setUpcomingEventsAddModal] = useState(false);
	const [users, setUsers] = useState<any[]>([]);
	const [totalNotifications, setTotalNotifications] = useState(0);
	const [upcomingEventsDeleteModal, setUpcomingEventsDeleteModal] = useState(false);
	const [pushId, setPushId] = useState("")
	const fetchSchedule = async () => {
		try {
			const body = {
				searchKeyword: searchKeyword,
				perPage: perPage,
				page: currentPage,
				// stage: 'created',
				// startDate: '2024-11-11T18:45:11.105Z',
				// endDate: '2024-11-11T18:45:11.105Z',
				// status: 1
			};
			const response = await getSchedules(body);

			if (response.error) {
				console.log(response.error);
			} else {
				setNotifications(response.data);
				setTotalNotifications(response.dataCount);
			}
		} catch (error) {
			toast.error('Failed to fetch Notifications');
		} finally {
			setIsLoadingTemplate(false);
		}
	};

	useEffect(() => {
		fetchSchedule();
	}, [currentPage, perPage, searchKeyword]);

	const fetchUsers = async () => {
		try {
			const body = {
				status: 1,
			};

			const response = await getUsers(body);

			if (response.error) {
				console.log(response.error);
			} else {
				setUsers(response.data);
			}
		} catch (error) {
			toast.error('Failed to fetch users');
		}
	};

	useEffect(() => {
		fetchUsers();
	}, []);

	const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setSearchKeyword(e.target.value);
		setCurrentPage(1);
	};

	// BEGIN :: Upcoming Events
	const [upcomingEventsInfoOffcanvas, setUpcomingEventsInfoOffcanvas] = useState(false);
	const handleUpcomingDetails = () => {
		setUpcomingEventsInfoOffcanvas(!upcomingEventsInfoOffcanvas);
	};

	const [editNotification, setEditNotification] = useState<any>(null);
	const [upcomingEventsEditOffcanvas, setUpcomingEventsEditOffcanvas] = useState(false);

	type HandleUpcomingEdit = (user: User) => void;

	const handleUpcomingEdit: HandleUpcomingEdit = async (user) => {
		try {
			const response = await getSchedulesById(user._id);
			if (response.error) {
				console.log(response.error);
			} else {
				setEditNotification(response.data);
				setUpcomingEventsEditOffcanvas((prev) => !prev);
			}
		} catch {
			console.log('Failed to fetch user');
		}
		formik.setErrors({});

	};

	const handleDelete = async () => {
		try {
			const responce = await deleteShedule(pushId);
			if (responce.error) {
				toast.error(responce.error);
			} else {
				setUpcomingEventsDeleteModal(false)
				toast.success('Notification deleted successfully')
				fetchSchedule();
			}
		} catch (error: any) {
			toast.error(error)
		}
	};

	const formik = useFormik<FormValues>({
		initialValues: {
			notification: {
				title: '',
				body: ''
			},
			data: {
				from: ''
			},
			to: [],
			scheduledAt: '',
		},
		validationSchema: Yup.object({
			notification: Yup.object({
				title: Yup.string().required('Title is required'),
				body: Yup.string().required('Body is required'),
			}),
			data: Yup.object({
				from: Yup.string().required('From is required'),
			}),
			to: Yup.array()
				.min(1, 'Select at least one user')
				.required('To is required'),
		}),
		onSubmit: async (values: FormValues, formikHelpers: FormikHelpers<FormValues>) => {
			try {
				const response = await editSchedule(editNotification?._id, values);

				if (response.error) {
					throw new Error(response.error);
				}

				fetchSchedule();
				formikHelpers.resetForm();
				setUpcomingEventsEditOffcanvas(false);
				toast.success('Notification edited successfully');
			} catch (error: any) {
				toast.error(error.message || 'Failed to edit notification');
			}
		},
	}
	)

	const addFormik = useFormik<FormValues>({
		initialValues: {
			notification: {
				title: '',
				body: ''
			},
			data: {
				from: ''
			},
			to: [],
			scheduledAt: '',
		},
		validationSchema: Yup.object({
			notification: Yup.object({
				title: Yup.string().required('Title is required'),
				body: Yup.string().required('Body is required'),
			}),
			data: Yup.object({
				from: Yup.string().required('From is required'),
			}),
			to: Yup.array()
				.min(1, 'Select at least one user')
				.required('To is required'),
			scheduledAt: Yup.string().required('Scheduled date is required'),
		}),
		onSubmit: async (values: FormValues, formikHelpers: FormikHelpers<FormValues>) => {
			try {
				const formattedScheduledAt = new Date(values.scheduledAt).toISOString();
				const response = await addShedule({
					...values,
					scheduledAt: formattedScheduledAt,
				});

				if (response.error) {
					throw new Error(response.error);
				}

				fetchSchedule();
				formikHelpers.resetForm();
				setUpcomingEventsAddModal(false);
				toast.success('Notification added successfully');
			} catch (error: any) {
				toast.error(error.message || 'Failed to add notification');
			}
		},
	}
	)
	const handleStatusChange = async (id: string, status: number) => {
		const result = await scheduleStatusChange(id, { status: status });
		if (result.error) {
			toast.error(result.error);
		} else {
			toast.success('Notification status changed successfully!');
			fetchSchedule();
		}
	};

	const handleSelectChange = (
		selectedOptions: MultiValue<{ value: string; label: string }>,
	) => {
		const usersArray = selectedOptions.map((option: any) => {
			const user = users.find(user => user._id === option.value);
			return user ? {
				_id: user._id,
				fName: user.fName,
				lName: user.lName,
				email: user.email,
			} : null;
		}).filter(Boolean);

		formik.setFieldValue('to', usersArray);
	};

	const handleSelectChangeAdd = (
		selectedOptions: MultiValue<{ value: string; label: string }>,
	) => {
		const usersArray = selectedOptions.map((option: any) => {
			const user = users.find(user => user._id === option.value);
			return user ? {
				_id: user._id,
				fName: user.fName,
				lName: user.lName,
				email: user.email,
			} : null;
		}).filter(Boolean);

		addFormik.setFieldValue('to', usersArray);
	};

	useEffect(() => {
		if (editNotification) {
			formik.setValues({
				notification: {
					title: editNotification.notification.title,
					body: editNotification.notification.body,
				},
				data: {
					from: editNotification.data.from,
				},
				to: editNotification.to.map((user: User) => ({
					_id: user._id,
					fName: user.fName,
					lName: user.lName,
					email: user.email,
				})),
				scheduledAt: '',
			});
		}
	}, [editNotification]);

	return (
		<>
			{isLoadingTemplate && (
				<div
					style={{
						position: 'fixed', // Fixed position to cover the entire viewport
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						backgroundColor: 'rgba(0, 0, 0, 0.5)', // Black background with 50% opacity
						display: 'flex', // Use flexbox to center the spinner
						justifyContent: 'center', // Center horizontally
						alignItems: 'center', // Center vertically
						zIndex: 9999, // Ensure it appears above other content
					}}
				>
					<Spinner size="3rem" /> {/* Adjust size as needed */}
				</div>
			)}
			<PageWrapper>
				<Page container='fluid'>
					<Card>
						<CardHeader >
							<div className='d-flex justify-content-between align-items-center w-100'>
								{/* Search Input */}
								<div className='col-md-4'>
									<Input
										placeholder='Search notifications...'
										value={searchKeyword}
										onChange={handleSearchChange}
										type='search'
									// icon='Search'
									/>
								</div>

								<Button
									color={darkModeStatus ? 'light' : 'dark'}
									isLight
									icon='Add'
									onClick={() => {
										setUpcomingEventsAddModal(true);
										addFormik.resetForm();
									}}
								>
									Add Notification
								</Button>
							</div>
						</CardHeader>
						<CardBody className='table-responsive'>
							<table className='table table-modern'>
								<thead>
									<tr>
										<td aria-labelledby='Image' style={{ width: 60 }} />
										<th className='cursor-pointer text-decoration-underline'>
											Date / Time{' '}
											<Icon size='lg' icon='FilterList' />
										</th>
										<th>Title</th>
										<th>Body</th>
										<th>Users</th>
										<th>Stage</th>
										<th>Status</th>
										<td aria-labelledby='Actions' />
									</tr>
								</thead>
								<tbody>
									{notifications ? notifications?.map((notification) => (
										<tr key={notification._id}>
											<td>
												<Button
													isOutline={!darkModeStatus}
													color='dark'
													isLight={darkModeStatus}
													className={classNames({
														'border-light': !darkModeStatus,
													})}
													icon='Info'
													onClick={handleUpcomingDetails}
													aria-label='Detailed information'
												/>
											</td>
											<td>
												<span className='text-nowrap'>
													{dayjs(notification.createdAt).format('MMM Do YYYY, h:mm a')}
												</span>
											</td>
											<td>{notification.notification.title || '-'}</td>
											<td>{notification.notification.body}</td>
											<td>{notification.to.length}</td>
											<td>{notification.stage || '-'}</td>
											<td>
												<Dropdown>
													<DropdownToggle hasIcon={false}>
														<Button
															isLink
															color={notification.status === 1 ? 'success' : 'danger'}
															icon='Circle'
															className='text-nowrap'>
															{notification.status === 1 ? 'Active' : 'Inactive'}
														</Button>
													</DropdownToggle>
													<DropdownMenu>
														{[0, 1].map((status) => (
															<DropdownItem
																key={status}
																onClick={() => handleStatusChange(notification._id, status)}>
																<div>
																	<Icon
																		icon='Circle'
																		color={status === 1 ? 'success' : 'danger'}
																	/>
																	{status === 1 ? 'Active' : 'Inactive'}
																</div>
															</DropdownItem>
														))}
													</DropdownMenu>
												</Dropdown>
											</td>
											<td className='d-flex gap-3'>
												<Button
													isOutline={!darkModeStatus}
													color='dark'
													isLight={darkModeStatus}
													className={classNames('text-nowrap', {
														'border-light': !darkModeStatus,
													})}
													icon='Edit'
													isDisable={(notification?.status === 1 && notification?.stage === 'created') ? false : true}
													onClick={() => handleUpcomingEdit(notification)}>
													Edit
												</Button>
												<Button
													isOutline={!darkModeStatus}
													color='danger'
													isLight={darkModeStatus}
													className={classNames('text-nowrap', {
														'border-light': !darkModeStatus,
													})}
													icon='Delete'
													onClick={() => {
														setUpcomingEventsDeleteModal(true); // Open the modal
														setPushId(notification._id); // Set the template ID for deletion
													}}
												/>
											</td>
										</tr>
									)) : <td colSpan={10} className='text-center py-4'>No notifications found.</td>}
								</tbody>
							</table>
						</CardBody>
						<PaginationButtons
							setCurrentPage={setCurrentPage}
							currentPage={currentPage}
							perPage={perPage}
							setPerPage={setPerPage}
							data={notifications || []}
							label="notifications"
							totalItems={totalNotifications}
						/>
					</Card >
					<OffCanvas
						setOpen={setUpcomingEventsEditOffcanvas}
						isOpen={upcomingEventsEditOffcanvas}
						titleId="upcomingEdit"
						isBodyScroll
						placement="end"
					>
						<OffCanvasHeader setOpen={setUpcomingEventsEditOffcanvas}>
							<OffCanvasTitle id="upcomingEdit">Edit User Notification</OffCanvasTitle>
						</OffCanvasHeader>
						<OffCanvasBody>
							<div className="row g-4">
								{/* Notification Title Field */}
								<div className="col-12">
									<FormGroup id="notificationTitle" label="Notification Title">
										<Input
											id="notification.title"
											name="notification.title"
											type="text"
											onChange={formik.handleChange}
											onBlur={formik.handleBlur}
											value={formik.values.notification.title}
											isTouched={formik.touched.notification?.title}
											invalidFeedback={formik.errors.notification?.title}
										/>
									</FormGroup>
								</div>
								{/* Notification Body Field */}
								<div className="col-12">
									<FormGroup id="notificationBody" label="Notification Body">
										<Input
											id="notification.body"
											name="notification.body"
											type="text"
											onChange={formik.handleChange}
											onBlur={formik.handleBlur}
											value={formik.values.notification.body}
											isTouched={formik.touched.notification?.body}
											invalidFeedback={formik.errors.notification?.body}
										/>
									</FormGroup>
								</div>
								{/* Data From Field */}
								<div className="col-12">
									<FormGroup id="dataFrom" label="From">
										<Input
											id="data.from"
											name="data.from"
											type="text"
											onChange={formik.handleChange}
											onBlur={formik.handleBlur}
											value={formik.values.data.from}
											isTouched={formik.touched.data?.from}
											invalidFeedback={formik.errors.data?.from}
										/>
									</FormGroup>
								</div>

								{/* Users Multi-Select Field */}
								<div className="col-12">
									<FormGroup id="scheduledAt" label="Select Users">
										<Select
											isMulti
											value={formik.values.to.map(user => ({
												value: user._id,
												label: user.fName,
											}))}
											options={users.map(user => ({
												value: user._id,
												label: user.fName,
											}))}
											onChange={handleSelectChange}
											aria-label="Select Users"
										/>
										<>
											{formik.touched.to && formik.errors.to && (
												<div className='invalid-feedback d-block'>
													{Array.isArray(formik.errors.to)
														? formik.errors.to.join(', ')
														: formik.errors.to}
												</div>
											)}
										</>
									</FormGroup>
								</div>
							</div>
						</OffCanvasBody>
						<div className="row m-0">
							<div className="col-12 p-3">
								<Button
									color="info"
									className="w-100"
									onClick={formik.handleSubmit}
								>
									Save
								</Button>
							</div>
						</div>
					</OffCanvas>
					<Modal
						setIsOpen={setUpcomingEventsAddModal}
						isOpen={upcomingEventsAddModal}
						titleId="userAdd"
						isCentered
						isScrollable
						size="lg"
					>
						<ModalHeader setIsOpen={setUpcomingEventsAddModal}>
							<h5 id="userAdd">Add User</h5>
						</ModalHeader>
						<ModalBody>
							<div className="row g-4">
								<div className="col-6">
									<FormGroup id="notificationTitle" label="Notification Title">
										<Input
											id="notification.title"
											name="notification.title"
											type="text"
											onChange={addFormik.handleChange}
											onBlur={addFormik.handleBlur}
											value={addFormik.values.notification.title}
											isTouched={addFormik.touched.notification?.title}
											invalidFeedback={addFormik.errors.notification?.title}
										/>
									</FormGroup>
								</div>
								<div className="col-6">
									<FormGroup id="notificationBody" label="Notification Body">
										<Input
											id="notification.body"
											name="notification.body"
											type="text"
											onChange={addFormik.handleChange}
											onBlur={addFormik.handleBlur}
											value={addFormik.values.notification.body}
											isTouched={addFormik.touched.notification?.body}
											invalidFeedback={addFormik.errors.notification?.body}
										/>
									</FormGroup>
								</div>
								<div className="col-6">
									<FormGroup id="dataFrom" label="From">
										<Input
											id="data.from"
											name="data.from"
											type="text"
											onChange={addFormik.handleChange}
											onBlur={addFormik.handleBlur}
											value={addFormik.values.data.from}
											isTouched={addFormik.touched.data?.from}
											invalidFeedback={addFormik.errors.data?.from}
										/>
									</FormGroup>
								</div>
								<div className="col-6">
									<FormGroup id="scheduledAt" label="Scheduled At">
										<Input
											id="scheduledAt"
											name="scheduledAt"
											type="datetime-local"
											onChange={addFormik.handleChange}
											onBlur={addFormik.handleBlur}
											value={addFormik.values.scheduledAt}
											isTouched={addFormik.touched.scheduledAt}
											invalidFeedback={addFormik.errors.scheduledAt}
										/>
									</FormGroup>
								</div>
								<div className="col-6">
									<FormGroup id="scheduledUser" label="Select User">
										<Select
											isMulti

											options={users.map(user => ({
												value: user._id,
												label: user.fName,
											}))}
											onChange={handleSelectChangeAdd}
											value={addFormik.values.to.map(user => ({
												value: user._id,
												label: user.fName,
											}))}
											styles={{
												control: (base: any, state: any) => ({
													...base,
													borderColor: addFormik.touched.to && addFormik.errors.to ? '#f35421' : base.borderColor,
													borderRadius: '1rem'
												}),
											}}
											aria-label="Select Users"
											onBlur={() => addFormik.setFieldTouched('to')} // Trigger validation on blur
										/>
										<>
											{addFormik.touched.to && addFormik.errors.to && (
												<div className='invalid-feedback d-block'>
													{Array.isArray(addFormik.errors.to)
														? addFormik.errors.to.join(', ') // Join array errors into a string
														: addFormik.errors.to}
												</div>
											)}
										</>
									</FormGroup>
								</div>
							</div>
						</ModalBody>
						<ModalFooter className="bg-transparent">
							<Button
								color="info"
								className="w-100"
								onClick={addFormik.handleSubmit} // Use addFormik's handleSubmit
							>
								Save
							</Button>
						</ModalFooter>
					</Modal>
					<Modal
						setIsOpen={setUpcomingEventsDeleteModal}
						isOpen={upcomingEventsDeleteModal}
						titleId="templateAdd"
						isCentered
						isScrollable
						size="lg"
					>
						<ModalHeader setIsOpen={setUpcomingEventsDeleteModal}>
							<h5 id="templateAdd">Delete Push notification</h5>
						</ModalHeader>
						<ModalBody>
							<div className="row g-4 text-center">
								<div className="col-12">
									<SvgDeleteForever
										style={{
											color: darkModeStatus ? '#FFFFFF' : '#FF0000', // Adjust colors dynamically
											height: '50px', // Make the icon larger
											width: '50px',
										}}
									/>
								</div>
								<div className="col-12">
									<p className="mt-3">Are you sure you want to delete this Push notification?</p>
								</div>
							</div>
						</ModalBody>
						<ModalFooter className="bg-transparent d-flex justify-content-between">
							<Button
								isOutline
								color="info"
								className="me-2 flex-grow-1"
								onClick={() => setUpcomingEventsDeleteModal(false)} // Close the modal
							>
								Cancel
							</Button>
							<Button
								color="info"
								className="ms-2 flex-grow-1"
								onClick={handleDelete} // Trigger delete action
							>
								Confirm
							</Button>
						</ModalFooter>
					</Modal>
				</Page>
			</PageWrapper>
		</>
	);
};

export default PushNotificationPage;